import { useQuery } from '@tanstack/react-query';

import { queryClient } from 'tools/tan-stack-query';

import { ScheduleTab } from '../domain';
import { scheduleOrderService, scheduleQueryKeys } from '../infra/services';

export function useScheduleTab() {
  const { data: activeTab = ScheduleTab.InProgress } = useQuery({
    queryKey: scheduleQueryKeys.tab(),
    queryFn: scheduleOrderService.getScheduleOrdersTab,
    staleTime: Infinity,
    cacheTime: Infinity,
    initialData: scheduleOrderService.getScheduleOrdersTab,
  });

  function setActiveTab(tab: ScheduleTab) {
    scheduleOrderService.setScheduleOrdersTab(tab);
    queryClient.setQueryData(scheduleQueryKeys.tab(), tab);
  }

  return { activeTab, setActiveTab };
}
